import React from "react";
import OwnerSurvey from "./OwnerSurvey";

interface Props {
  setStep: React.Dispatch<React.SetStateAction<number>>;
  step: number;
  barId: string;
}

export default function GiveScoreBottomSheet(props: Props) {
  const { setStep, step, barId } = props;

  return (
    <>
      {/* <SelectScorer
        setStep={setStep}
        open={step == 1}
        onDismiss={() => setStep(0)}
      /> */}
      <OwnerSurvey
        barId={barId}
        setStep={setStep}
        open={step === 2}
        onDismiss={() => setStep(0)}
      />
      {/* <CompanySurvey
        setStep={setStep}
        open={step === 3}
        onDismiss={() => setStep(0)}
      /> */}
    </>
  );
}
